<template>
  <div class="animated fadeIn">
    <Forms ref="frmDefault"
      :title="editMode ? 'EDITAR MAPEAMENTO DE GRUPOS AD' : 'CADASTRO DE MAPEAMENTO DE GRUPOS AD'"
      :showClearButton="true"
      :showSaveButton="true"
      :showBackButton="true"
      :disabledKeyUpEnter="true"
      :isModal="isModal"
      v-on:Clear="onClear"
      v-on:Back="$emit('Back')"
      v-on:Save="onSave">
      <div class="form-group row">
        <div class="col-md-12">
          <label for="groupSelect">
            <small v-if="form.adGroupDn.required" class="text-danger">*</small>
            Grupo AD
          </label>
          <b-form-select
            id="groupSelect"
            v-model="form.adGroupDn.value"
            :options="availableGroupsOptions"
            :disabled="editMode || loadingGroups"
            :required="form.adGroupDn.required"
            :state="form.adGroupDn.state"
            @change="onGroupSelected"
          >
            <template #first>
              <b-form-select-option :value="null" disabled>
                {{ loadingGroups ? 'Carregando grupos...' : '-- Selecione um grupo --' }}
              </b-form-select-option>
            </template>
          </b-form-select>
          <small class="text-muted d-block mt-1">
            Grupos que a conta de serviço tem acesso
          </small>
        </div>
      </div>

      <div class="form-group row" v-if="form.adGroupDn.value && editMode">
        <div class="col-md-12">
          <label for="groupDn">DN do Grupo</label>
          <b-form-input
            id="groupDn"
            v-model="form.adGroupDnDisplay.value"
            disabled
            size="sm"
          ></b-form-input>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-md-12">
          <label for="permissoes">
            <small v-if="form.permissoes.required" class="text-danger">*</small>
            Permissões
          </label>
          <v-select
            multiple
            id="permissoes"
            v-model="form.permissoes.value"
            :options="permissoesOptions"
            :reduce="(option) => option.value"
            class="w-100"
            label="name"
            :required="form.permissoes.required"
            placeholder="Selecione as permissões"
          >
            <template v-slot:no-options>
              Nenhuma permissão encontrada.
            </template>
          </v-select>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-md-12">
          <label for="acessos">
            <small v-if="form.acessos.required" class="text-danger">*</small>
            Acessos
          </label>
          <v-select
            multiple
            id="acessos"
            v-model="form.acessos.value"
            :options="acessosOptions"
            :reduce="(option) => option.value"
            class="w-100"
            label="name"
            :required="form.acessos.required"
            placeholder="Selecione os acessos"
          >
            <template v-slot:no-options>
              Nenhum acesso encontrado.
            </template>
          </v-select>
        </div>
      </div>

    </Forms>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'
import 'vue-select/dist/vue-select.css'

import { PERMISSIONS_OPTIONS, ACCESS_OPTIONS } from '@/shared/constants/permissionsAndAccessOptions'
import adSyncService from '@/shared/http/repositories/adsync/adsync'

export default {
  name: 'GroupMappingsAdd',
  mixins: [ActionsForm],
  props: {
    isModal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      editMode: false,
      loadingGroups: false,
      availableGroups: [],
      mappedGroups: [],
      selectedGroupDn: null,
      data: {
        id: null,
        adGroupName: '',
        adGroupDn: '',
        permissoes: [],
        acessos: [],
        autoProvisioning: true,
        active: true
      },
      form: {
        adGroupDn: { value: null, required: true, state: null },
        adGroupDnDisplay: { value: '', required: false, state: null },
        permissoes: { value: [], required: false, state: null },
        acessos: { value: [], required: false, state: null },
        autoProvisioning: { value: true, required: false, state: null }
      },
      permissoesOptions: PERMISSIONS_OPTIONS,
      acessosOptions: ACCESS_OPTIONS
    }
  },
  computed: {
    availableGroupsOptions () {
      // Se estiver no modo de edição, mostrar todos os grupos (incluindo o atual)
      if (this.editMode) {
        return this.availableGroups.map(group => ({
          value: group.groupDn,
          text: `${group.groupName} (${group.totalUsers} usuários)`
        }))
      }

      // Se estiver adicionando, filtrar grupos já mapeados
      const mappedGroupDns = this.mappedGroups.map(m => m.adGroupDn)
      return this.availableGroups
        .filter(group => !mappedGroupDns.includes(group.groupDn))
        .map(group => ({
          value: group.groupDn,
          text: `${group.groupName} (${group.totalUsers} usuários)`
        }))
    }
  },
  mounted () {
    this.loadAvailableGroups()
    this.loadMappedGroups()
  },
  methods: {
    onLoad () {
    },
    onClear () {
      this.form.adGroupDn.value = null
      this.form.adGroupDnDisplay.value = ''
      this.form.permissoes.value = []
      this.form.acessos.value = []
      this.form.autoProvisioning.value = true
      this.data = {
        id: null,
        adGroupName: '',
        adGroupDn: '',
        permissoes: [],
        acessos: [],
        autoProvisioning: true,
        active: true
      }
    },
    onEdit (obj) {
      if (obj) {
        loading.push()
        this.editMode = true
        Tools.SetValueInForm(this.form, this.data, obj)
        this.form.adGroupDn.value = obj.adGroupDn
        this.form.adGroupDnDisplay.value = obj.adGroupDn
        this.form.permissoes.value = obj.permissoes || []
        this.form.acessos.value = obj.acessos || []
        this.form.autoProvisioning.value = obj.autoProvisioning !== undefined ? obj.autoProvisioning : true
        this.data.id = obj.id
        this.data.active = obj.active !== undefined ? obj.active : true
        loading.pop()
      }
    },
    onGroupSelected (groupDn) {
      if (groupDn) {
        const group = this.availableGroups.find(g => g.groupDn === groupDn)
        if (group) {
          this.form.adGroupDnDisplay.value = group.groupDn
          this.data.adGroupDn = group.groupDn
          this.data.adGroupName = group.groupName
        }
      }
    },
    async loadAvailableGroups () {
      this.loadingGroups = true
      try {
        const response = await adSyncService.getAvailableGroups()
        this.availableGroups = response.data || []
      } catch (error) {
        toast.error('Erro ao carregar grupos: ' + (error.message || 'Erro desconhecido'))
      } finally {
        this.loadingGroups = false
      }
    },
    async loadMappedGroups () {
      try {
        const response = await adSyncService.getAllMappings()
        this.mappedGroups = response.data || []
      } catch (error) {
        console.error('Erro ao carregar mapeamentos existentes:', error)
      }
    },
    onCreate () {
      if (!this.form.adGroupDn.value) {
        toast.warning('Selecione um grupo AD')
        this.form.adGroupDn.state = false
        return
      }

      loading.push()

      this.data.adGroupDn = this.form.adGroupDn.value
      this.data.permissoes = this.form.permissoes.value || []
      this.data.acessos = this.form.acessos.value || []
      this.data.autoProvisioning = true // Sempre true (campo oculto)

      adSyncService.createMapping(this.data)
        .then((response) => {
          loading.close()
          toast.success('Mapeamento criado com sucesso!')
          this.onClear()
          this.$emit('Back')
        })
        .catch(this.onException)
    },
    onUpdate () {
      if (!this.form.adGroupDn.value) {
        toast.warning('Selecione um grupo AD')
        this.form.adGroupDn.state = false
        return
      }

      loading.push()

      this.data.id = parseInt(this.data.id)
      this.data.adGroupDn = this.form.adGroupDn.value
      this.data.permissoes = this.form.permissoes.value || []
      this.data.acessos = this.form.acessos.value || []
      this.data.autoProvisioning = true // Sempre true (campo oculto)

      adSyncService.updateMapping(this.data.id, this.data)
        .then((response) => {
          loading.close()
          toast.success('Mapeamento atualizado com sucesso!')
          this.onClear()
          this.$emit('Back')
        })
        .catch(this.onException)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/ADSync/components/add/GroupMappingsAdd.vue